import { call, put, takeLatest } from "redux-saga/effects";
import request from "../../utils/request";

function* getAllNaturalPersons(payload) {
  try {
    yield put({
      type: "FETCH_NATURAL_PERSONS_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/naturalPersons?page=${payload.value.page}&search=${payload.value.search}&offset=${payload.value.offset}`;
    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_NATURAL_PERSON_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Falied load",
        message: "Falied load NaturalPersons",
      },
    });
    yield put({
      type: "FETCH_NATURAL_PERSON_ERROR",
    });
  }
}

function* postNaturalPerson(payload) {
  try {
    yield put({ type: "CREATE_NATURAL_PERSON_REQUESTING" });

    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/naturalPersons`;

    const formData = new FormData();
    formData.append("ciudad", payload.value.ciudad);
    formData.append("pais", payload.value.pais);
    formData.append("tipo_solicitud", payload.value.tipo_solicitud);
    formData.append("clase_vinculacion", payload.value.clase_vinculacion);
    formData.append("apellidos", payload.value.apellidos);
    formData.append("nombres", payload.value.nombres);
    formData.append("tipo_doc", payload.value.tipo_doc);
    formData.append("numero_documento", payload.value.numero_documento);
    formData.append("fec_nac", payload.value.fec_nac);
    formData.append("lugar_nacimiento", payload.value.lugar_nacimiento);
    formData.append("nacionalidad", payload.value.nacionalidad);
    formData.append("ocupacion", payload.value.ocupacion);
    formData.append("profesion", payload.value.profesion);
    formData.append("telefono", payload.value.telefono);
    formData.append("celular", payload.value.celular);
    formData.append("direccion_res", payload.value.direccion_res);
    formData.append("mcpio", payload.value.mcpio);
    formData.append("email", payload.value.email);
    formData.append(
      "maneja_recursos_publicos",
      payload.value.maneja_recursos_publicos
    );
    formData.append("cargo_poder_publico", payload.value.cargo_poder_publico);
    formData.append(
      "reconocimiento_publico",
      payload.value.reconocimiento_publico
    );
    formData.append("persona_expuesta", payload.value.persona_expuesta);
    formData.append(
      "obligaciones_trib_otro_pais",
      payload.value.obligaciones_trib_otro_pais
    );
    formData.append("moneda_extranjera", payload.value.moneda_extranjera);
    formData.append("financieros_exterior", payload.value.financieros_exterior);
    formData.append(
      "cuentas_moneda_extranjera",
      payload.value.cuentas_moneda_extranjera
    );
    formData.append("tipo_operacion", payload.value.tipo_operacion);
    formData.append(
      "cuentas_extranjeras",
      payload.value.cuentas_extranjeras
        ? payload.value.cuentas_extranjeras
        : "[]"
    );
    formData.append("file_rnt_rut", payload.value.file_rnt_rut);
    formData.append("file_rut", payload.value.file_rut);
    formData.append("file_doc_repre_legal", payload.value.file_doc_repre_legal);
    formData.append(
      "file_cert_constitucion",
      payload.value.file_cert_constitucion
    );
    formData.append("fuente_referencia", payload.value.fuente_referencia);
    formData.append("office", payload.value.office);
    formData.append("promotor", payload.value.promotor);
    formData.append("sys", payload.value.sys);
    formData.append("estado", payload.value.estado);

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      }),
      body: formData,
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "CREATE_NATURAL_PERSON_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful save",
        message: "Successful save NaturalPerson",
      },
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Falied save",
        message: "Falied save NaturalPerson",
      },
    });
    yield put({
      type: "CREATE_NATURAL_PERSON_ERROR",
    });
  }
}

function* postNaturalPersonSignature(payload) {
  try {
    yield put({ type: "SIGNATURE_NATURAL_PERSON_REQUESTING" });

    yield put({
      type: "SHOW_LOADING",
    });
    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/naturalPersons/signature`;

    const formData = new FormData();
    formData.append("codigo_verificacion", payload.value.codigo_verificacion);
    formData.append("file_firma", payload.value.file_firma);

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      }),
      body: formData,
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "SIGNATURE_NATURAL_PERSON_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful save",
        message: "Successful save NaturalPerson",
      },
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Falied save",
        message: "Falied save NaturalPerson",
      },
    });
    yield put({
      type: "SIGNATURE_NATURAL_PERSON_ERROR",
    });
  }
}

function* getNaturalPersonById(payload) {
  try {
    yield put({
      type: "READ_NATURAL_PERSON_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/naturalPersons/${payload.value.id}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "READ_NATURAL_PERSON_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "READ_NATURAL_PERSON_ERROR",
    });
  }
}

function* deleteNaturalPersonById(payload) {
  try {
    yield put({
      type: "DELETE_NATURAL_PERSON_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/naturalPersons/changeState/${payload.value.idNaturalPerson}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "DELETE_NATURAL_PERSON_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful disable",
        message: "Successful disable NaturalPerson",
      },
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Falied disable",
        message: "Falied disable NaturalPerson",
      },
    });
    yield put({
      type: "DELETE_NATURAL_PERSON_ERROR",
    });
  }
}

function* updateNaturalPerson(payload) {
  try {
    yield put({
      type: "UPDATE_NATURAL_PERSON_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/naturalPersons/${payload.value.id}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "UPDATE_NATURAL_PERSON_SUCCESS",
      value: response,
    });
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful update",
        message: "Successful update NaturalPerson",
      },
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Falied update",
        message: "Falied update NaturalPerson",
      },
    });
    yield put({
      type: "UPDATE_NATURAL_PERSON_ERROR",
    });
  }
}

export function* watchNaturalPerson() {
  yield takeLatest("FETCH_NATURAL_PERSONS_REQUEST", getAllNaturalPersons);
  yield takeLatest("CREATE_NATURAL_PERSON_REQUEST", postNaturalPerson);
  yield takeLatest(
    "SIGNATURE_NATURAL_PERSON_REQUEST",
    postNaturalPersonSignature
  );
  yield takeLatest("READ_NATURAL_PERSON_REQUEST", getNaturalPersonById);
  yield takeLatest("DELETE_NATURAL_PERSON_REQUEST", deleteNaturalPersonById);
  yield takeLatest("UPDATE_NATURAL_PERSON_REQUEST", updateNaturalPerson);
}
